import request from '../request'

export default {
  getCategoriasRecurso: () => {
    return request.get('recurso_categoria')
  }
}
